export default __webpack_public_path__ + "static/sygnet-wasyluk-240c10cb4070b99e5f9fd7f1c920db5d.svg";